@if (!colorPickerOpen) {
  @if (brandColors$ | async; as brandColors) {
    <div class="colors-title">Brand Colors</div>
    <div class="colors brand-colors">
      @for (color of brandColors; track color) {
        <div
          class="color"
          [class.active]="currentColor === color.color"
          [appTooltip]="color.name"
          [ngStyle]="{ 'background-color': color.color }"
          (click)="selectColor(color.color)"
          appClickTrack
          name="color"
          location="color-selector"
        ></div>
      }
    </div>
  }
  <div class="colors preset-colors">
    @for (color of presetColors; track color) {
      <div
        class="color"
        [class.active]="currentColor === color"
        [ngStyle]="{ 'background-color': color }"
        (click)="selectColor(color)"
        appClickTrack
        name="color"
        location="color-selector"
      ></div>
    }
    <div
      class="color custom-color"
      (click)="customColorClick($event)"
      appClickTrack
      name="custom-color"
      location="color-selector"
    ></div>
  </div>
  @if (recentColors.length || galleryColors.length) {
    <div class="colors other-colors">
      @for (color of recentColors; track color) {
        <div
          class="color"
          [class.active]="currentColor === color"
          [ngStyle]="{ 'background-color': color }"
          (click)="selectColor(color)"
          appClickTrack
          name="color"
          location="color-selector"
        ></div>
      }
      @for (color of galleryColors; track color) {
        <div
          class="color"
          [class.active]="currentColor === color"
          [ngStyle]="{ 'background-color': color }"
          (click)="selectColor(color)"
          appClickTrack
          name="color"
          location="color-selector"
        ></div>
      }
    </div>
  }
  @if (allowReset) {
    <div class="reset-button">
      <app-button-menu-item
        name="reset-color"
        location="color-selector"
        [color]="'simple'"
        icon="undo"
        [fullWidth]="true"
        (onClick)="selectColor(undefined)"
      >
        <span>Reset Color</span>
      </app-button-menu-item>
    </div>
  }
} @else {
  <app-color-picker
    [(color)]="currentColor"
    [allowOpacity]="allowOpacity"
    (colorChange)="colorPickerChange()"
  ></app-color-picker>
}
